// src/sections/Technology.jsx

import { motion } from "framer-motion";
import { technologies, siteMeta } from "../data/siteContent";
import SectionIntro from "../components/motion/SectionIntro";
import { cardReveal, staggerParent, viewportOnce } from "../utils/motion";

export default function Technology() {
  return (
    <section className="section-block section-block--light" id="technology">
      <div className="container-shell technology-shell">
        <SectionIntro
          eyebrow={technologies.eyebrow}
          title={technologies.title}
        />

        <motion.div
          className="technology-grid"
          variants={staggerParent}
          initial="hidden"
          whileInView="show"
          viewport={viewportOnce}
        >
          {technologies.items.map((item) => (
            <motion.article
              key={item.title}
              className="technology-card"
              variants={cardReveal}
            >
              <div className="technology-card__icon" />
              <h3>{item.title}</h3>
              <p>{item.desc}</p>
            </motion.article>
          ))}
        </motion.div>

        <motion.div
          className="technology-cta"
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, amount: 0.25 }}
          transition={{ duration: 0.8 }}
        >
          <div>
            <h3>Build action from measurable transport intelligence.</h3>
            <p>
              Dryvziro is designed for partners who need operational visibility,
              not generic sustainability language.
            </p>
          </div>

          <a
            href={siteMeta.ctaHref}
            target="_blank"
            rel="noreferrer"
            className="btn btn--primary"
          >
            {siteMeta.ctaLabel}
          </a>
        </motion.div>
      </div>
    </section>
  );
}
